import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CUSTOMER_DETAIL_VERIFY, CUSTOMER_DETAIL_VERIFY_SUCCESS, CUSTOMER_DETAIL_VERIFY_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* CustomerDetailVerify({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { clientId, programId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/clients/${clientId}/programs/${programId}/users/verify`,
      method: 'POST',
      data: payload.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CUSTOMER_DETAIL_VERIFY_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CUSTOMER_DETAIL_VERIFY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CUSTOMER_DETAIL_VERIFY_ERROR, payload: error });
  }
}

export function* watchCustomerDetailVerify() {
  yield takeEvery(CUSTOMER_DETAIL_VERIFY, CustomerDetailVerify);
}

function* CustomerDetailVerifySaga() {
  yield all([fork(watchCustomerDetailVerify)]);
}

export default CustomerDetailVerifySaga;
